module.exports = __webpack_public_path__ + "media/yitian.c214369f.mp3";